import { FETCH_DAY_ORDERS_BEGIN, FETCH_DAY_ORDERS_SUCCESS, FETCH_DAY_ORDERS_FAILURE } from './dayOrdersActions';

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export default function dayOrderReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DAY_ORDERS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_DAY_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.orders,
      };
    case FETCH_DAY_ORDERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        items: [],
      };
    default:
      return state;
  }
}
